import { getCookie } from 'bv';
import { locale } from 'bv-i18n';

export default (value, options) => {
  const { currency, decimalPlaces } = {
    currency: getCookie('currency_iso_code'),
    ...options,
  };

  const formatterOptions = {
    style: 'currency',
    currency,
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  };

  return new Intl.NumberFormat(locale(), formatterOptions).format(value);
};
